import React from 'react';
import { Map } from 'immutable';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { FormattedMessage, defineMessages } from 'react-intl';
import { withTheme } from 'styled-components';

import Form from 'components/Form';
import FormHeader from 'components/Form/FormHeader';
import fieldTypes from 'components/Form/fieldTypes';
import SettingsPage from 'components/Pages/User/SettingsPage';
import { selectUser } from 'selectors/user';
import { setUser } from 'actions/user';
import settingsMessages from 'components/settingsMessages';
import updateDetails from '../updateDetails';

const messages = defineMessages({
  editEmailAddressTitle: {
    defaultMessage: 'Edit Email Address',
  },
  emailAddressUpdated: {
    defaultMessage: 'Email address updated successfully.',
  },
  errorUpdating: {
    defaultMessage: 'Could not update email address, please try again later.',
  },
});

const formFields = [
  fieldTypes.email,
  {
    ...fieldTypes.password,
    helpMessage: <FormattedMessage {...settingsMessages.passwordMessage} />,
  },
];

class EditEmailAddress extends React.Component {
  static propTypes = {
    user: PropTypes.instanceOf(Map),
    setUser: PropTypes.func,
  };

  constructor(props) {
    super(props);
    this.state = {
      error: false,
    };
  }

  onSubmit = (values, callback) => {
    const email = this.props.user.get('email');
    const newDetails = {
      email: values.email,
    };

    updateDetails({ email, password: values.password, newDetails })
      .then(({ user }) => {
        this.props.setUser(user);
        callback({ success: true });
      })
      .catch(error => {
        const message = error.message === 'forbidden' ? settingsMessages.forbidden : messages.errorUpdating;
        this.setState({ error: message });
        callback({ error: true });
      });
  };

  render() {
    return (
      <SettingsPage>
        <FormHeader title={<FormattedMessage {...messages.editEmailAddressTitle} />} requiredFields={true} />
        <Form
          fields={formFields}
          onSubmit={this.onSubmit}
          submitButtonLabel={<FormattedMessage {...settingsMessages.saveChanges} />}
          errorHeader={<FormattedMessage {...settingsMessages.updateError} />}
          errorMessage={this.state.error ? <FormattedMessage {...this.state.error} /> : ''}
          successHeader={<FormattedMessage {...settingsMessages.success} />}
          successMessage={<FormattedMessage {...messages.emailAddressUpdated} />}
        />
      </SettingsPage>
    );
  }
}

const mapStateToProps = state => ({
  user: selectUser(state),
});

export default connect(mapStateToProps, { setUser })(withTheme(EditEmailAddress));
